import { MeowLightbox } from './MeowLightbox';
import { render } from 'preact';
import { MeowLightboxContextProvider } from './context';

import { apiUrl, restNonce } from './settings';
import { scrapThePage } from './helpers';

import PhotoSwipeCore from './photoswipe/core';

// Let's create a queue for the dynamic content
let mwlDynamicContentQueue = [];

// Updated function to add images to the queue
const addToMeowLightboxQueue = (imgElement) => {
  if (!(imgElement instanceof HTMLElement) || imgElement.tagName.toLowerCase() !== 'img') {
    console.error('🚫 Invalid image element:', imgElement);
    console.warn('ℹ️ The parameter should be an img HTML element');
    return;
  }
  const imageUrl = imgElement.src;
  if (!imageUrl) {
    console.error('🚫 Image element does not have a src attribute:', imgElement);
    return;
  }
  mwlDynamicContentQueue.push({ element: imgElement, url: imageUrl });
};

// Updated function using fetch
const regenerate_mwl_data = async (images) => {
  try {
    const response = await fetch(`${apiUrl}regenerate_mwl_data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': restNonce,
      },
      body: JSON.stringify({ images }),
    });

    // Check if the response is OK
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      return data.data;
    } else {
      console.error('Server responded with an error:', data);
      return null;
    }
  } catch (err) {
    if (err.message) {
      alert(err.message);
    }
    return null;
  }
};

const renderMeowLightbox = async () => {
  console.log('🎞️ Rendering Meow Lightbox');

  // If there is content in the queue, send a request to get the new mwl_data value
  if (mwlDynamicContentQueue.length > 0) {

    console.log('🚚 Sending request to get the new mwl_data for', mwlDynamicContentQueue);

    // Extract URLs to send to the server
    const imagesToSend = mwlDynamicContentQueue.map((item) => ({ url: item.url }));

    const newImages = await regenerate_mwl_data(imagesToSend);

    if (newImages) {
      // Build mwl_data as { id: data }
      const mwlDataUpdates = {};
      newImages.forEach((imageData) => {

        if ( imageData.data.success === false ) {
          console.error('Error fetching image data:', imageData.id, imageData.data);
          return;
        }

        mwlDataUpdates[imageData.id] = imageData.data;

        // Find the corresponding item in the queue
        const item = mwlDynamicContentQueue.find((item) => item.url === imageData.url);
        if (item && item.element) {
          // Add data-id attribute to the image element
          item.element.setAttribute('data-mwl-img-id', imageData.id);
          // Add
        }
      });

      // Update mwl_data
      window.mwl_data = { ...window.mwl_data, ...mwlDataUpdates };

      // Clear the queue
      mwlDynamicContentQueue = [];
    }
  }

  const engine = window.mwl_settings.settings.engine;

  // Remove any existing root element
  const existingRoot = document.getElementById('mwl-root');
  if (existingRoot) {
    existingRoot.parentNode.removeChild(existingRoot);
  }

  // Create a new root element
  document.body.appendChild(document.createRange().createContextualFragment('<div id="mwl-root"></div>'));

  const infiniteScrollElements = document.querySelectorAll('.mgl-infinite-scroll');
  const infiniteScrollableGalleries = Array.from(infiniteScrollElements).map((node) => node.previousSibling);

  if (engine === 'photoswipe') {
    render(<PhotoSwipeCore />, document.getElementById('mwl-root'));
  }

  if (engine === 'default') {
    render(
      <MeowLightboxContextProvider infiniteScrollableGalleries={infiniteScrollableGalleries}>
        <MeowLightbox />
      </MeowLightboxContextProvider>,
      document.getElementById('mwl-root')
    );
  }
};

/**
 * After a small timeout to ensure most things are loaded.
 */
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    renderMeowLightbox();
  }, 300);
});

window.renderMeowLightbox = renderMeowLightbox;
window.addToMeowLightboxQueue = addToMeowLightboxQueue;